import { Box } from "@chakra-ui/react"
import { Outlet } from "react-router-dom"
import { useSpaceContext } from "../space/api/context"
import AuthWrapper from "./components/AuthWrapper"
import useExternalAuthNavigate from "./utils/useExternalAuthNavigate"

const AuthLayout = () => {
  useExternalAuthNavigate()
  const { space } = useSpaceContext()

  return (
    <Box
      id="auth-view"
      minH="100vh"
      display="flex"
      flexDir="column"
      alignItems="center"
      justifyContent="center"
    >
      {/* <ThemeBackground
        background={space.theme.background}
        // TODO: remove this override once the theme.background_overlay
        // is working properly!
        overlayOpacity={0}
      /> */}
      <AuthWrapper
        bg="white"
        // bg="background"
        minH={["calc(100vh - 50px)", "auto"]}
        maxW="500px"
        mt={["50px", "70px"]}
        mb={["0px", "70px"]}
        borderRadius={["0", "2xl"]}
      >
        <Outlet />
      </AuthWrapper>
    </Box>
  )
}

export default AuthLayout
